<template>
	<div>
		<el-card>
			<el-form :inline="true" ref="selectForm" :model="formInline" class="demo-form-inline" style="" size="mini">
				<el-form-item label="姓名">
					<el-input v-model="formInline.employe_name" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input v-model="formInline.employe_tel" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item label="门店名称">
					<el-input v-model="formInline.store_name" placeholder="可模糊搜索" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getData()">查询</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card style="margin-top: 10px;">
			<el-table :data="data.list" style="width: 100%;text-align: center;" size="mini">
				<el-table-column align="center" header-align="center" label="编号" width="100">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="employe_name" label="账号姓名">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="employe_tel" label="手机号">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="employe_idcard" label="身份证号">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="employe_postion" label="职务">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="store_name" label="商户">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="employe_adddate" label="添加时间">
					<template slot-scope="scope">
						{{timeFormat(scope.row.employe_adddate,'yyyy-mm-dd hh:MM:ss')}}
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" label="修改密码" width="150">
					<template slot-scope="scope">
						<div style="color:#32D1B9;">
							<el-button  size="mini" type="text"
								@click="updatePasswordForm.employe_id=(scope.row.employe_id);outerVisible=true">修改密码</el-button>
						</div>
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end; ">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="formInline.page" :page-sizes="[10, 20, 50, 100]" :page-size="formInline.limit"
					layout="total, sizes, prev, pager, next, jumper" :total="data.total">
				</el-pagination>
			</div>
		</el-card>
		
		<el-dialog title="修改密码" :visible.sync="outerVisible" @closed="()=>{$refs['updatePasswordForm'].resetFields()}">
			<el-form :inline="false" :model="updatePasswordForm" ref="updatePasswordForm" :rules="rules" label-width="auto"
				class="demo-form-inline" size="mini">
				<div style="display: grid;grid-template-columns: 1fr">
					<el-form-item label="新密码" prop="password" :rules="[{ required: true, message: '请输入密码',min:5, trigger: 'change' }]">
						<el-input style="width: 178px;" v-model="updatePasswordForm.password" clearable
							placeholder="请输入新密码"></el-input>
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="outerVisible = false">取 消</el-button>
				<el-button size="mini" type="primary" @click="onUpdatePassword">确定修改</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				updatePasswordForm:{
					password:'',
					employe_id:''
				},
				outerVisible:false,
				formInline: {
					page: 1,
					limit: 10
				},
				data: {}
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			toInfo(store) {
				this.$router.push({
					path: '/storeInfo',
					query: {
						store_id: store.store_id
					}
				});
			},

			handleSizeChange(e) {
				this.formInline.limit = e;
				this.getData();
			},
			handleCurrentChange(e) {
				this.formInline.page = e;
				this.getData();
			},
			deleteStore(index, row) {
				var that = this;
				this.$confirm('确定取消认证吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '考虑以下',
					type: 'warning'
				}).then(() => {
					row.store_state = 0;
					that.$axios.post('zuche/admin/updateStore', row).then(function(res) {
						if (res.data.success) {
							that.getData();
						} else {
							that.$message.error(res.data.message);
						}
					});
				})
			},
			onUpdatePassword() {
				var that = this;
				this.$confirm('确定修改吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '考虑一下',
					type: 'warning'
				}).then(() => {
					that.$axios.post('zuche/employe/updateEmployePassword', that.updatePasswordForm).then(function(res) {
						if (res.data.success) {
							that.getData();
							that.outerVisible=false;
						} else {
							that.$message.error(res.data.message);
						}
					});
				})
			},
			
			getData() {
				var that = this;
				this.$axios.post('zuche/employe/getEmployeList', this.formInline).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.data = res.data.result;
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
	.el-dialog {
		width: fit-content;
	}
</style>


// WEBPACK FOOTER //
// src/components/employeManage.vue